// services/file/FileService.ts
import { BaseService } from "@services/BaseService";

class FileService extends BaseService {
  getFileAnomalies(projectId: string, fileId: string) {
    return this.get(`/projects/${projectId}/files/${fileId}/anomalies`);
  }

  resolveAnomaly(projectId: string, fileId: string, finding_id: string) {
    return this.patch(
      `/projects/${projectId}/files/${fileId}/anomalies/${finding_id}/resolve`,
      {}
    );
  }

  ignoreAnomaly(projectId: string, fileId: string, finding_id: string) {
    return this.patch(
      `/projects/${projectId}/files/${fileId}/anomalies/${finding_id}/ignore`,
      {}
    );
  }
  ignoreAllAnomalies(projectId: string, fileId: string) {
    return this.patch(
      `/projects/${projectId}/files/${fileId}/anomalies/ignore-all`,
      {}
    );
  }
}

export const fileService = new FileService();
